import ACTIONS from 'application/constants'

export const getAkteMetaRequest = (hashUserKey, needsToken = true) => ({
    type: ACTIONS.AKTE_META_DATA_REQUEST,
    hashUserKey,
    needsToken
})

export const populateAkteMeta = (payload) => ({
    type: ACTIONS.AKTE_META_DATA_POPULATE,
    payload
})

export const getAkteMetaFailed = () => ({
    type: ACTIONS.AKTE_META_DATA_FAILED,
})